<template>
  <div :class="{ switcher: true }">
    <div
      :class="{ 'switcher-button': true, disable: disable, actived: !disable && value === '!AND' }"
      @click="disable ? null : $emit('input', '!AND')"
    >
      {{ $i18n.t('default.and') }}
    </div>
    <div
      :class="{ 'switcher-button': true, disable: disable, actived: !disable && value === '!OR' }"
      @click="disable ? null : $emit('input', '!OR')"
    >
      {{ $i18n.t('default.or') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwitcherButton',
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.switcher {
  width: 120px;
  height: 26px;
  border: 0.6px solid rgba(0, 0, 0, 0.12);
}
.switcher-button {
  width: 50%;
  height: 26px;
  background-color: #eaeaf4;
  float: left;
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;
  color: rgba(32, 33, 36, 0.3);
  cursor: pointer;
  text-transform: uppercase;
}
.disable {
  cursor: default !important;
}
.actived {
  color: white !important;
  background-color: #1a73e8 !important;
}
</style>
